import BaseApiService from './base-api-service';

import { Comment } from '../models/comment';

export default class CommentsApiService extends BaseApiService {
  section: string;

  constructor(section: string) {
    super();
    this.section = section;
  }

  getComments = async (): Promise<Comment[]> => {
    const result = await this.getResource(`/GetComments?type=${this.section}`);
    return result;
  };

  addNewComment = async (data: Comment): Promise<Comment> => {
    const result = await this.postResource(`/PostComments`, {
      ...data,
      type: this.section,
    });

    return result;
  };

  updateComment = async (data: Comment): Promise<Comment> => {
    const result = await this.putResource(`/PutComments/${data.id}`, {
      ...data,
      type: this.section,
    });
    return result;
  };

  deleteComment = async (id: number): Promise<number> => {
    const result = await this.deleteResource(`/DeleteComments/${id}`);
    return result;
  };

  public async setCustomPrice(type: string, value: string): Promise<unknown> {
    const response = await this.postResource(`/PostComments`, {
      text: value,
      type,
    });

    return response;
  }

  public async updateCustomPrice(id: number, type: string, value: string): Promise<unknown> {
    const response = await this.putResource(`/PutComments/${id}`, {
      text: value,
      type,
    });

    return response;
  }

  public async removeCustomPrice(id: number): Promise<unknown> {
    const response = await this.deleteResource(`/DeleteComments/${id}`);

    return response;
  }
}
